var exports = {
  "kL": "xe564cbfb--4118ef--container",
  "VE": "xe564cbfb--4118ef--visually-hidden",
  "Qs": "xe564cbfb--4118ef--content",
};

module.exports = exports;
